import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { getOldNotifications, markReadNotification } from '../../../api/misc';
import { getNotifications } from '../../../api/Notification';
import { notificationSelector } from '../../../store';
import { clearNotification } from '../../../store/Notification';
import type { QueryParamsInterface } from '../../../types/Shared';

export const usePatchReadNotification = () => {
  const dispatch = useDispatch();
  const notification = useSelector(notificationSelector);
  const queryClient = useQueryClient();

  return useMutation(() => markReadNotification(notification.notificationId), {
    onSuccess: () => {
      dispatch(clearNotification());
      queryClient.invalidateQueries(['get-notifications']);
    },
  });
};

export const useFetchNotifications = ({ perPage }: { perPage: number }) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: ['get-notifications', perPage],
    queryFn: () => getOldNotifications({ perPage }),
    keepPreviousData: true,
    staleTime: 5000,
  });
};

interface INotificationsHookProps {
  params?: QueryParamsInterface;
}

export const useNotifications = ({ params }: INotificationsHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: ['get-notifications', params],
    queryFn: () => getNotifications({ params }),
    staleTime: 30000,
    refetchInterval: 30000,
  });
};
